import React from "react";
import ImageSlider from "../common/ImageSlider";
import { settings } from "../../constants/spaceFeedImageSettings";
import "../../styles/Comunity.css";
import ProviderCardBody from "./ProviderCardBody";
import { Link, useNavigate } from "react-router-dom";

const ProviderListing = ({ spaceFeedList, fetchProviderListing }) => {

  return (
    <div className="row">
      {spaceFeedList?.map((item, index) => (
        <div className="col-12 col-md-6 col-lg-4 mb-4" key={index}>
          <div className="card-list w-100 h-100" style={{ cursor: "pointer" }}>
            <Link style={{ textDecoration: "none" }} to={`/property-detail/${item?.spaceFeedId}`}>
              {item?.spaceFeedMedia?.length > 0 && (
                <>
                  {item?.spaceFeedMedia.length === 1 ? (
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                        height: "300px",
                      }}
                    >
                      {item?.spaceFeedMedia[0]?.url?.includes("mp4") ? (
                        <video
                          type="video/mp4"
                          className="card-img-top"
                          src={item?.spaceFeedMedia[0]?.url}
                          alt="Card cap"
                          controls
                          style={{
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <img
                          className="card-img-top"
                          src={
                            item?.spaceFeedMedia[0]?.url ||
                            "https://picsum.photos/seed/picsum/200/200"
                          }
                          alt="Card cap"
                          style={{
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      )}
                    </div>
                  ) : (
                    <ImageSlider
                      height={300}
                      className="card-img-top"
                      settings={settings}
                      item={item}
                      icon={"none"}
                    />
                  )}
                </>
              )}
              <ProviderCardBody
                fetchProviderListing={fetchProviderListing}
                item={item}
              />
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProviderListing;
